export function useScriptHelper(scriptType = 'text/javascript') {
    async function createScriptWithOptions(options, src, async = true) {
        const script = document.createElement('script');
        script.src = src;
        script.type = scriptType;
        script.async = async;
        await Promise.all(options.map((option) => {
            return script.setAttribute(option.name, option.value);
        }));
        return script;
    }
    async function removeScript(context, script, resetHTML = false) {
        const _script = typeof script === 'string' ? context.querySelector(`#${script}`) : script;
        if (_script !== null) {
            await context.removeChild(_script);
        }
        if (resetHTML === true) {
            context.innerHTML = '';
        }
    }
    return {
        createScriptWithOptions,
        removeScript,
    };
}
//# sourceMappingURL=script.js.map